import { render } from "./BetFooter.vue?vue&type=template&id=f665a308"
import script from "./BetFooter.vue?vue&type=script&lang=js"
export * from "./BetFooter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__